
export interface ISearchResultDTO {
    searchTerm: string;
    results: ISearchResultHitDTO[];
    facets: IFacetDTO[];
    totalResults: number;
    trackingId: string;
    suggestion: string;
    hideFiltersAndCategories: boolean;
}

export interface ISearchResultHitDTO {
    title: string;
    url: string;
    description: string;
    categories: string[];
    fileType: string;
    hitId: string;
    isBestBet: string;
    searchResultImage: string;
}

export interface IFacetDTO {
    fieldName: string;
    displayName: string;
    facetDisplayOption: FacetDisplayOption[];
    terms: ITermDTO[];
    viewMoreFiltersMessage: string;
    hideMoreFiltersMessage: string;
    maxFiltersToDisplay: number;
}

export interface ITermDTO {
    id: number;
    displayName: string;
    fieldName: string;
    term: string;
    hits: number;
    selected: boolean;
    icon: TermIcon;
}

export enum TermIcon {
    PDF,
    WebPage
}

export enum FacetDisplayOption {
    Checkbox,
    Dropdown
}

export interface ISearchRequestDTO {
    searchTerm: string;
    pageSize: number;
    pageNumber: number;
    facets: IFacetDTO[];
    context: string;
    sortField: number;
    sortDirection: number;
    dateSortRelevanceFilter: number;
    includeSuggestion: boolean;
}

export interface IAutocompleteResults {
    hits: IHit[];
    activeHit: number;
    isActive: boolean;
}

export const DefaultAutoCompleteResults: IAutocompleteResults = Object.freeze({
    hits: [],
    activeHit: -1,
    isActive: false,
})



export interface IHit {
    query: string;
    type: string;
}

export interface ITrackClick {
    searchTerm: string;
    trackingId: string;
    hitId: string;
}

export const FILE_EXTENSION_TERM: string = "SearchFileExtension";